<mat-drawer-container class="example-container">
    <!-- <router-outlet></router-outlet> -->
    <mat-drawer
        #drawer
        class="example-sidenav side"
        mode="side"
        opened="true"
        disableClose="true"
    >
        <mat-accordion class="example-headers-align">
            <mat-expansion-panel
                *ngIf="m.indexOf('DASHBOARD') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/dashboard/dashboard' ||
                    tab_active === '/dashboard/cost'
                "
            >
                <mat-expansion-panel-header class="main" style="border: none">
                    <mat-panel-title>
                        {{ "MENU.DASHBOARD" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('DASHBOARD') > -1">
                    <a
                        class="menu-in"
                        routerLink="/dashboard/dashboard"
                        [routerLinkActive]="['active-link']"
                    >
                        <span class="submain">{{
                            "MENU.SALE_DASHBOARD" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        subM.indexOf('REVENUE_DASHBAORD') > -1 &&
                        userProfile?.position == 'COMPANY'
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/dashboard/cost"
                        [routerLinkActive]="['active-link']"
                    >
                        <span class="submain">{{
                            "MENU.DB_REVE" | translate
                        }}</span></a
                    >
                </div>
                <!-- <div class="menu-in submain">Password</div> -->
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('PERSONAL_DATA') > -1"
                class="menuMain"
                [expanded]="tab_active === '/account/info'"
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.PERSONAL_DATA" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('ACCOUNT_INFO') > -1">
                    <a
                        class="menu-in"
                        routerLink="/account/info"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.ACCOUNT_INFO" | translate
                        }}</span>
                    </a>
                </div>
                <!-- <div class="menu-in submain">Password</div> -->
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('FOOD_MANAGEMENT') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/food-mgmt/food' ||
                    tab_active === '/food-mgmt/category' ||
                    tab_active === '/food-mgmt/food-customize' ||
                    tab_active === '/food-mgmt/tray' ||
                    tab_active === '/food-mgmt/additional-group'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.FOOD_MGMT" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('FOOD') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/food-mgmt/food"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.FOOD" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('CATEGORY') > -1">
                    <a
                        class="menu-in"
                        routerLink="/food-mgmt/category"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.CATEGORY" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('FOOD_CUSTOMIZE') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/food-mgmt/food-customize"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.FOOD_CUS" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('TRAY') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/food-mgmt/additional-group"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "GLOBAL.ADDITIONAL_GROUP" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('TRAY') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/food-mgmt/tray"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.TRAY" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('STOCK_MANAGEMENT') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/stock/category' ||
                    tab_active === '/stock/material' ||
                    tab_active === '/stock/supplier' ||
                    tab_active === '/stock/purchase' ||
                    tab_active === '/stock/transfer' ||
                    tab_active === '/stock/stock-hold' ||
                    tab_active === '/stock/check-stock' ||
                    tab_active === '/stock/unit' ||
                    tab_active === '/stock/issue' ||
                    tab_active === '/stock/processing'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.STOCK_MGMT" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('MATERIAL_PRODUCT') > -1">
                    <a
                        class="menu-in"
                        routerLink="/stock/category"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">
                            {{ "MENU.CATEGORY" | translate }}</span
                        ></a
                    >
                </div>
                <div *ngIf="subM.indexOf('MATERIAL_PRODUCT') > -1">
                    <a
                        class="menu-in"
                        routerLink="/stock/material"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">
                            {{ "MENU.MATERIAL_PRO" | translate }}</span
                        ></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/stock/unit"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">
                            {{ "MENU.UNIT" | translate }}</span
                        ></a
                    >
                </div>
                <div *ngIf="subM.indexOf('SUPPLIER') > -1">
                    <a
                        class="menu-in"
                        routerLink="/stock/supplier"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.SUPPLIER" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('PURCHASE') > -1">
                    <a
                        class="menu-in"
                        routerLink="/stock/purchase"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.PURCHASE" | translate
                        }}</span></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/stock/processing"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">
                            {{ "GLOBAL.PROCESSING" | translate }}</span
                        ></a
                    >
                </div>
                <div *ngIf="subM.indexOf('TRANSFER') > -1">
                    <a
                        class="menu-in"
                        routerLink="/stock/transfer"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.TRANSFER" | translate
                        }}</span></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/stock/issue"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "GLOBAL.ISSUE" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('CHECK_STOCK') > -1">
                    <a
                        class="menu-in"
                        routerLink="/stock/check-stock"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.CHECK_STOCK" | translate
                        }}</span></a
                    >
                </div>
                <!-- <div *ngIf="subM.indexOf('TRANSFER') > -1">
          <a
            class="menu-in"
            routerLink="/stock/transfer"
            [routerLinkActive]="['active-link']"
            ><span class="submain">{{ "MENU.TRANSFER" | translate }}</span></a
          >
        </div> -->
            </mat-expansion-panel>
            <mat-expansion-panel
                class="menuMain"
                *ngIf="
                    userProfile?.position != 'BRANCH' &&
                    m.indexOf('CUSTOMER_MANAGEMENT') > -1
                "
                [expanded]="tab_active === '/customer-mgmt/membership'"
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.CUSTOMER_MGMT" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('MEMBERSHIP') > -1">
                    <a
                        class="menu-in"
                        routerLink="/customer-mgmt/membership"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.MEMBERSHIP" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="menuMain"
                *ngIf="m.indexOf('USER_MANAGEMENT') > -1"
                [expanded]="
                    tab_active === '/user-mgmt/branch' ||
                    tab_active === '/user-mgmt/subordinate' ||
                    tab_active === '/user-mgmt/employee'
                "
            >
                <mat-expansion-panel-header class="main">
                    <div>
                        <mat-panel-title>
                            {{ "MENU.USER_MGMT" | translate }}
                        </mat-panel-title>
                    </div>
                </mat-expansion-panel-header>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('BRANCH_INFO') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/user-mgmt/branch"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.BRANCH_INFO" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('SUBORDINATE') > -1">
                    <a
                        class="menu-in"
                        routerLink="/user-mgmt/subordinate"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.SUBORDINATE" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        userProfile?.position == 'BRANCH' &&
                        subM.indexOf('EMPLOYEE') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/user-mgmt/employee"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain"
                            >{{ "MENU.EMPLOYEE" | translate }}
                        </span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('PROMOTION') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/promotion/promotion' ||
                    tab_active === '/promotion/redeem'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.PROMO" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('PROMOTION') > -1">
                    <a
                        class="menu-in"
                        routerLink="/promotion/promotion"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.PROMO" | translate
                        }}</span></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/promotion/redeem"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "GLOBAL.REDEEM" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('MOBILE_MANAGEMENT') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/mobile-mgmt/announcement' ||
                    tab_active === '/mobile-mgmt/notification' ||
                    tab_active === '/mobile-mgmt/help-center' ||
                    tab_active === '/mobile-mgmt/popular-search'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.MOBILE_MGMT" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('ANNOUNCEMENT') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/mobile-mgmt/announcement"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.ANNOUNCEMENT" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('NOTIFICATION') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/mobile-mgmt/notification"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.NOTIFICATION" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('HELP_CENTER') > -1">
                    <a
                        class="menu-in"
                        routerLink="/mobile-mgmt/help-center"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.HELP_CENTER" | translate
                        }}</span></a
                    >
                </div>
                <div
                    *ngIf="
                        userProfile?.position != 'BRANCH' &&
                        subM.indexOf('POPULAR_SEARCH') > -1
                    "
                >
                    <a
                        class="menu-in"
                        routerLink="/mobile-mgmt/popular-search"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.POPULAR_SEARCH" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('FEEDBACK') > -1"
                class="menuMain"
                [expanded]="tab_active === '/feedback/feedback-order'"
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.FEEDBACK" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <div *ngIf="subM.indexOf('FEEDBACK_ORDER') > -1">
                    <a
                        class="menu-in"
                        routerLink="/feedback/feedback-order"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.FEEDBACK_ORDER" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <!-- <mat-expansion-panel
        *ngIf="m.indexOf('OMISE_REPORT') > -1"
        class="menuMain"
        [expanded]="tab_active === '/omise/transfer-report'"
      >
        <mat-expansion-panel-header class="main">
          <mat-panel-title>
            {{ "MENU.OMISE_REPORT" | translate }}</mat-panel-title
          >
        </mat-expansion-panel-header>

        <div *ngIf="subM.indexOf('TRANSFER_REPORT') > -1">
          <a
            class="menu-in"
            routerLink="/omise/transfer-report"
            [routerLinkActive]="['active-link']"
            ><span class="submain">{{
              "MENU.TRANSFER_REPORT" | translate
            }}</span></a
          >
        </div>
      </mat-expansion-panel> -->
            <mat-expansion-panel
                *ngIf="m.indexOf('ADJUST') > -1"
                class="menuMain"
                [expanded]="tab_active === '/adjust-order/adjust'"
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.ADJUST_ORDER" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('ADJUSTORDER') > -1">
                    <a
                        class="menu-in"
                        routerLink="/adjust-order/adjust"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.ADJUST_ORDER" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('REPORT') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/report/order-report' ||
                    tab_active === '/report/transaction-logs' ||
                    tab_active === '/report/promotion-report' ||
                    tab_active === '/omise/transfer-report' ||
                    tab_active === '/report/inventory-report' ||
                    tab_active === '/report/movement-report' ||
                    tab_active === '/report/seller-report'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.REPORT" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('ORDER_REPORT') > -1">
                    <a
                        class="menu-in"
                        routerLink="/report/order-report"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.ORDER_REPORT" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('TRANSACTION_LOGS') > -1">
                    <a
                        class="menu-in"
                        routerLink="/report/transaction-logs"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.TRANS_LOGS" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('PROMOTION_REPORT') > -1">
                    <a
                        class="menu-in"
                        routerLink="/report/promotion-report"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.PROMO_REPORT" | translate
                        }}</span></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/report/seller-report"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">
                            {{ "GLOBAL.R_SALE_VOLUME" | translate }}</span
                        ></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/report/inventory-report"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">
                            {{ "GLOBAL.INVENTORY_REPORT" | translate }}</span
                        ></a
                    >
                </div>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/report/movement-report"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "GLOBAL.STOCK_MOVEMENT" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('TRANSFER_REPORT') > -1">
                    <a
                        class="menu-in"
                        routerLink="/omise/transfer-report"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.OMISE_REPORT" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                *ngIf="m.indexOf('CONFIG') > -1"
                class="menuMain"
                [expanded]="
                    tab_active === '/config/platform' ||
                    tab_active === '/partner/config-gp' ||
                    tab_active === '/config/manage-point'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.CONFIG" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('PLATFORM') > -1">
                    <a
                        class="menu-in"
                        routerLink="/config/platform"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.PLATFORM" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('CONFIG_GP') > -1">
                    <a
                        class="menu-in"
                        routerLink="/partner/config-gp"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.CONFIG_GP" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('CONFIG_GP') > -1">
                    <a
                        class="menu-in"
                        routerLink="/config/manage-point"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "GLOBAL.MANAGE_POINT" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="menuMain"
                *ngIf="m.indexOf('INVOICE') > -1"
                [expanded]="tab_active === '/invoice/invoice'"
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.INVOICE" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div>
                    <a
                        class="menu-in"
                        routerLink="/invoice/invoice"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.INVOICE" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
            <mat-expansion-panel
                class="menuMain"
                *ngIf="m.indexOf('INCOME_EXPENSE') > -1"
                [expanded]="
                    tab_active === '/income-expense/ie-type' ||
                    tab_active === '/income-expense/ie'
                "
            >
                <mat-expansion-panel-header class="main">
                    <mat-panel-title>
                        {{ "MENU.IE" | translate }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <div *ngIf="subM.indexOf('ACCOUNT_CATEGORY') > -1">
                    <a
                        class="menu-in"
                        routerLink="/income-expense/ie-type"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.IE_TYPE" | translate
                        }}</span></a
                    >
                </div>
                <div *ngIf="subM.indexOf('ACCOUNT') > -1">
                    <a
                        class="menu-in"
                        routerLink="/income-expense/ie"
                        [routerLinkActive]="['active-link']"
                        ><span class="submain">{{
                            "MENU.IE" | translate
                        }}</span></a
                    >
                </div>
            </mat-expansion-panel>
        </mat-accordion>
        <div class="version" (dblclick)="checkV()">v {{ version }}</div>
        <!-- <button
      (click)="logout()"
      mat-icon-button
      class="example-icon btn-signout"
      aria-label="Example icon-button with share icon"
    >
      <mat-icon style="color: #154621; margin-right: 8px">logout</mat-icon>
      Sign out
    </button> -->
        <!-- <button (click)="drawer.toggle(); toggleSidenav()">sdadsadas</button> -->
    </mat-drawer>
</mat-drawer-container>
